import { TimeOutIcon } from "@repo/edtech-assets";
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from "@repo/edtech-ui-kit";

import st from "./ExpiredTestCover.module.scss";

type Props = {
  onClickContinue: () => void,
  onClickFinishTest: () => void,
  isFinishLoading?: boolean,
};

export const ExpiredTestCover = ({
  onClickContinue,
  onClickFinishTest,
  isFinishLoading = false,
}: Props) => {
  return (
    <div className={st.wrap}>
      <TimeOutIcon className={st.icon} />
      <h2 className={st.title}>
        Время истекло
      </h2>
      <p className={st.description}>
        Время, отведённое на прохождение теста, истекло. Вы можете продолжить отвечать
        на вопросы или завершить тестирование прямо сейчас
      </p>
      <div className={st.actions}>
        <Button
          className={st.btn}
          disabled={isFinishLoading}
          size={ButtonSize.Medium}
          variant={ButtonVariant.Outline}
          onClick={onClickContinue}
        >
          Продолжить
        </Button>
        <Button
          className={st.btn}
          disabled={isFinishLoading}
          size={ButtonSize.Medium}
          variant={ButtonVariant.Primary}
          onClick={onClickFinishTest}
        >
          Завершить тест
        </Button>
      </div>
    </div>
  );
};
